import React from 'react'
import {Route} from 'react-router-dom'

const RoutesWrapper = React.lazy(async () => import('./routes-wrapper'))

export const routes = <Route index path="*" element={<RoutesWrapper />} />
